var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.LoginShow,
          expression: "LoginShow"
        }
      ],
      staticClass: "loginContainer"
    },
    [
      _c("section", { staticClass: "main clearfix" }, [
        _c("i", { staticClass: "el-icon-close", on: { click: _vm.colse } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contFr fr" },
          [
            _vm.loginType == 1
              ? _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    staticStyle: {},
                    attrs: { model: _vm.ruleForm, "label-width": "1px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "formItems",
                        attrs: {
                          label: "",
                          prop: "userName",
                          rules: [
                            {
                              required: true,
                              message: "请输入手机号",
                              trigger: "blur"
                            },
                            {
                              required: true,
                              validator: _vm.isCellPhone,
                              trigger: "blur"
                            }
                          ]
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "iconfonts",
                          attrs: {
                            src: require("@/assets/images/icon/phone1.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "input clearfix",
                          attrs: {
                            placeholder: "请输入您的手机号",
                            maxlength: "11"
                          },
                          model: {
                            value: _vm.ruleForm.userName,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "userName", $$v)
                            },
                            expression: "ruleForm.userName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "formItems1",
                        staticStyle: { "margin-bottom": "22px" },
                        attrs: {
                          label: "",
                          prop: "loginCode",
                          rules: [
                            {
                              required: true,
                              message: "请输入计算结果",
                              trigger: "blur"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "clearfix" },
                          [
                            _c("el-input", {
                              staticClass: "input",
                              attrs: { placeholder: "请输入图形验证码" },
                              model: {
                                value: _vm.ruleForm.loginCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "loginCode", $$v)
                                },
                                expression: "ruleForm.loginCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "codeBox imgCode",
                          attrs: { src: _vm.imgCode, alt: "图形验证码" },
                          on: { click: _vm.getImgCodes }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "formItems1",
                        attrs: {
                          label: "",
                          prop: "smsCode",
                          rules: [
                            {
                              required: true,
                              message: "请输入短信验证码",
                              trigger: "blur"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "clearfix" },
                          [
                            _c("el-input", {
                              staticClass: "input",
                              attrs: { placeholder: "请输入短信验证码" },
                              model: {
                                value: _vm.ruleForm.smsCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "smsCode", $$v)
                                },
                                expression: "ruleForm.smsCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "codeBox code",
                            on: {
                              click: function($event) {
                                return _vm.getCode()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.codeTxt))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "cahngeLogin clearfix" }, [
                      _c(
                        "span",
                        {
                          class: [_vm.loginType == 2 ? "active" : "", "fr"],
                          on: {
                            click: function($event) {
                              return _vm.changeLoginType()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.loginType == 2 ? "验证码登录" : "密码登录"
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: {
                          "margin-bottom": "48px",
                          "margin-top": "72px"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "register",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.submitForm("ruleForm")
                              }
                            }
                          },
                          [_vm._v("登录账号")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "goLogin",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.goLogin }
                          },
                          [_vm._v("未注册账号，去注册")]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "el-form",
                  {
                    ref: "ruleForm1",
                    staticClass: "demo-ruleForm",
                    staticStyle: {},
                    attrs: { model: _vm.ruleForm, "label-width": "1px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "formItems",
                        attrs: {
                          label: "",
                          "label-width": "1",
                          prop: "userName",
                          rules: [
                            {
                              required: true,
                              message: "请输入手机号",
                              trigger: "blur"
                            },
                            {
                              required: true,
                              validator: _vm.isCellPhone,
                              trigger: "blur"
                            }
                          ]
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "iconfonts",
                          attrs: {
                            src: require("@/assets/images/icon/phone1.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "input clearfix",
                          attrs: {
                            placeholder: "请输入您的手机号",
                            maxlength: "11"
                          },
                          model: {
                            value: _vm.ruleForm.userName,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "userName", $$v)
                            },
                            expression: "ruleForm.userName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "formItems",
                        attrs: {
                          label: "",
                          prop: "passWord",
                          rules: [
                            {
                              required: true,
                              message: "请输入密码",
                              trigger: "blur"
                            },
                            { validator: _vm.validatePass, trigger: "blur" },
                            {
                              min: 8,
                              max: 12,
                              message: "长度在8到12个字符",
                              trigger: "blur"
                            }
                          ]
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "iconfonts",
                          attrs: {
                            src: require("@/assets/images/icon/paswd1.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "input",
                          attrs: {
                            "show-password": "",
                            placeholder: "请输入登录密码",
                            maxlength: "12"
                          },
                          model: {
                            value: _vm.ruleForm.passWord,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "passWord", $$v)
                            },
                            expression: "ruleForm.passWord"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "formItems1",
                        attrs: {
                          label: "",
                          prop: "loginCode",
                          rules: [
                            {
                              required: true,
                              message: "请输入计算结果",
                              trigger: "blur"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "clearfix" },
                          [
                            _c("el-input", {
                              staticClass: "input",
                              attrs: { placeholder: "请输入图形验证码" },
                              model: {
                                value: _vm.ruleForm.loginCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "loginCode", $$v)
                                },
                                expression: "ruleForm.loginCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "codeBox imgCode",
                          attrs: { src: _vm.imgCode, alt: "图形验证码" },
                          on: { click: _vm.getImgCodes }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "cahngeLogin clearfix" }, [
                      _c(
                        "span",
                        {
                          staticClass: "fl",
                          on: {
                            click: function($event) {
                              return _vm.forgtPass()
                            }
                          }
                        },
                        [_vm._v("忘记密码？")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: [_vm.loginType == 2 ? "active" : "", "fr"],
                          on: {
                            click: function($event) {
                              return _vm.changeLoginType()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.loginType == 2 ? "验证码登录" : "密码登录"
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: {
                          "margin-bottom": "48px",
                          "margin-top": "72px"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "register",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.submitForm("ruleForm1")
                              }
                            }
                          },
                          [_vm._v("登录账号")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "goLogin",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.goLogin }
                          },
                          [_vm._v("未注册账号，去注册")]
                        )
                      ]
                    )
                  ],
                  1
                )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("Messages", { ref: "messages", attrs: { tips: _vm.tipsTxt } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43cc691a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43cc691a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginPopup.vue
// module id = null
// module chunks = 